import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { formato } from 'src/app/shared/object/formato.model';
import { producto } from 'src/app/shared/object/producto.model';
import { producto_formatoJoin } from 'src/app/shared/object/producto_formatoJoin.model';
import { producto_impuesto } from 'src/app/shared/object/producto_impuesto.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { RutService } from 'src/app/shared/services/rut.service';
import { ProductoModalSeleccionarImpuestoComponent } from '../modal-seleccionar-impuesto/modal-seleccionar-impuesto.component';
import { ProductoModalVolumenPesoComponent } from '../modal-volumen-peso/modal-volumen-peso.component';
import * as _ from 'lodash';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { debounceTime, filter } from 'rxjs/operators';
import { ProductoService } from 'src/app/services/producto.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { IOperacionPermitidaQueryParams, RolOperacionService } from 'src/app/services/rol-operacion.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { ModalVerErroresComponent } from 'src/app/views/shared/modal-ver-errores/modal-ver-errores.component';

@Component({
  selector: 'app-productos-form-add-edit',
  templateUrl: './form-add-edit.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ProductosFormAddEditComponent implements OnInit {
  // Output
  @Output() onSuccess: EventEmitter<number> = new EventEmitter<number>();

  // Modales
  @ViewChild(ProductoModalSeleccionarImpuestoComponent, { static: true }) modalSeleccionarImpuestos: ProductoModalSeleccionarImpuestoComponent;
  @ViewChild(ProductoModalVolumenPesoComponent, { static: true }) modalSeleccionarPesoVolumen: ProductoModalVolumenPesoComponent;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;

  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  mode: 'ADD' | 'EDIT';
  formulario: FormGroup;
  rut_empresa: number;
  sucursal_codigo: number;
  codgo_modulo: number = 2;
  rut_usuario: number;
  private productoOriginal: producto;
  public formatoNombreComb1: string;
  public formatoNombreComb2: string;
  public codigo_impuesto: number = 0;
  public impuestoAdicPro: number;
  public fecha_registro: Date;
  public canEditExcentoIVA: boolean = true;
  private lastSku: string = '';
  private lastCodigoBarra: string = '';
  private isEditingStarted: boolean = false;
  private currentCodigoBarra: string = '';
  disabledContent: boolean = false;

  listaFormato: formato[];
  optionsUnidadMedida: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamiliaRubros: Array<any> = [];
  optionsUnidadNegocio: Array<any> = [];
  optionsFormato: Array<any> = [];
  public parametroNegocio: boolean = false;
  public parametroSeguimiento: boolean = false;

  listaProductoFormato: producto_formatoJoin[];

  private client: GraphQLClient = null;

  // Utils
  private log: any;

  constructor(
    client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private toastService: ToastService,
    private rutService: RutService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private productoService: ProductoService,
    private unidadNegocioService: UnidadNegocioService,
    private parametroEmpresaService: ParametroEmpresaService,
    private element: ElementRef,
    private rolOperacionService: RolOperacionService,
    private formatoProductosService: FormatoProductosService
  ) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS FORM ADD/EDIT');
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

    this.loadPermiteExentoIVA();
    this.obtenerElementos();

    this.createForm();
    this.formChangesSubscriptions();
    this.loadUnidadNegocio();
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        tipo: -1,
      },
    };
    this.optionsUnidadNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
    });
  }

  obtenerElementos() {
    let self = this;
    this.client.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            rubro {
              obtenerRubros(empresa_rut: $empresa_rut) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                    empresa_rut
                  }
                }
              }
            }
            formato {
              obtenerFormatos(empresa_rut: $empresa_rut) {
                respuesta {
                  registros {
                    empresa_rut
                    codigo
                    nombre
                    cantidad
                    formato_padre
                    fecha_registro
                    rut_usuario_creacion
                    rut_usuario_modificacion
                    es_compra
                    es_venta
                  }
                }
              }
            }
            unidad_medida {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
        },
        fetchPolicy: 'network-only',
      },
      function (respuesta) {
        const listaRubro = respuesta.data.rubro.obtenerRubros.respuesta.registros;
        self.optionsRubro = [];
        var sel: any;
        listaRubro.forEach((element) => {
          sel = { value: element.codigo, label: element.descripcion };
          self.optionsRubro.push(sel);
        });

        self.listaFormato = respuesta.data.formato.obtenerFormatos.respuesta.registros;
        self.optionsFormato = [];
        var sel: any;
        self.listaFormato.forEach((element) => {
          if (element.es_venta == true) {
            sel = { value: element.codigo, label: `${element.codigo} - ` + `${element.nombre} - ` + `${element.cantidad}` };
            self.optionsFormato.push(sel);
          }
        });

        const listaUnidad_Medida = respuesta.data.unidad_medida.obtenerTodos.respuesta.registros;
        self.optionsUnidadMedida = [];
        var sel: any;
        listaUnidad_Medida.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsUnidadMedida.push(sel);
        });
        // self.listaImpuesto = respuesta.data.impuesto.obtenerTodos.respuesta.registros;
      }
    );
  }

  loadPermiteExentoIVA() {
    const inputParams: IOperacionPermitidaQueryParams = {
      rut_usu: this.rut_usuario,
      codgo_modulo: 2,
      cod_operacion: 16,
    };

    this.rolOperacionService.operacionPermitida(inputParams, (allowed) => {
      this.canEditExcentoIVA = allowed;
    });
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rut_empresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.parametroNegocio = respuesta.valor_bool;
      this.log('Permite Unidad Negocio', this.parametroNegocio);
    });
  }

  public loadAndShow(parametro_negocio: boolean) {
    this.parametroNegocio = parametro_negocio;
  }

  createForm() {
    this.formulario = this.formBuilder.group({
      codigo: [''],
      empresa_rut: [''],
      sku: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      descripcion: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      descripcion_ext: [''],
      es_exento: [false],
      codigo_barras: ['', [Validators.minLength(5), Validators.maxLength(50)]],
      fecha_registro: [''],
      activo: [false],
      favorito: [false],
      familia_codigo: ['', [Validators.required]],
      tipo_producto_codigo: [''],
      unidad_medida_codigo: [''],
      afecto_reglas_comerciales: [true],
      no_aplica_descuento: [false],
      fecha_caducidad_combo: [''],
      fecha_inicio_combo: [''],
      rubro_codigo: ['', [Validators.required]],
      formato_combinacion1: [''],
      formato_combinacion2: [''],
      formato: [''],
      peso: [''],
      volumen: [''],
      unidad_negocio_codigo: [''],
      seguimiento: [false],
    });
  }

  formChangesSubscriptions() {
    this.formulario.get('rubro_codigo').valueChanges.subscribe((data) => {
      this.formulario.get('familia_codigo').setValue('');
      if (this.formulario.controls['rubro_codigo'].value == '' || this.formulario.controls['rubro_codigo'].value == undefined || this.formulario.controls['rubro_codigo'].value == null) {
      } else {
        this.obtenerFamiliasxRubros(this.formulario.controls['rubro_codigo'].value);
      }
    });

    this.formulario
      .get('sku')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((sku: string) => {
        if (this.mode !== 'ADD') return;
        if (!sku || sku === this.lastSku) return;
        this.lastSku = sku;
        if (this.formulario.get('sku').value) {
          this.formulario.get('sku').setValue(this.formulario.get('sku').value.trim());
        }
        this.ValidarSku(sku);
      });
    this.formulario
      .get('codigo_barras')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigoBarras: string) => {
        // if (this.mode !== 'ADD') return
        if (!codigoBarras || codigoBarras === this.lastCodigoBarra) return;
        this.lastCodigoBarra = codigoBarras;
        if (this.mode === 'EDIT' && !this.isEditingStarted) return;
        if (this.currentCodigoBarra === codigoBarras) return;
        if (this.formulario.get('codigo_barras').value) this.formulario.get('codigo_barras').setValue(this.formulario.get('codigo_barras').value.trim());
        this.ValidarCodigoBarras(codigoBarras);
      });
  }

  toggleCheckbox($event) {
    const checked = $event.target.checked;
    const self = this;
    console.log('El producto se encuentra? ', checked);

    if (checked == false) {
      //*Validacion para verificar si se encuentra en analisis de demanda y/o confirmación nota venta.
      // this.formulario.get('activo').setValue(true);
      const inputParams = {
        empresa_rut: this.rut_empresa,
        codigo: this.productoOriginal.codigo,
      };
      this.productoService.ValidarProductoParaFacturaMasiva(inputParams, ({ respuesta, mensajes }) => {
        const ok = respuesta !== null;
        const alert = mensajes.length > 0;
        //* Si el Producto se encuentra en el Analisis de demanda, el producto debe seguir activo

        if (alert) {
          self.modalVerErrores.loadAndShow(mensajes);
          // this.messageRendererService.showErrors(mensajes);
          this.formulario.get('activo').setValue(true);
          return;
        }

        // //* Si el Producto se encuentra en el Analisis de demanda, el producto debe seguir activo
        // if (respuesta.enAnalisisDemanda == true) {
        //   this.toastService.error('El Producto se encuentra en el analisis de demanda. No se puede desactivar el producto hasta terminar su proceso.');
        //   this.formulario.get('activo').setValue(true);
        // }

        // //* Si el Producto se encuentra en el Analisis de demanda, el producto debe seguir activo
        // if (respuesta.enConfirmacionNotaVenta == true) {
        //   this.toastService.error('El Producto se encuentra en Confirmar Nota de Venta. No se puede desactivar el producto hasta terminar su proceso.');
        //   this.formulario.get('activo').setValue(true);
        // }
      });
    }
  }

  OnchangeSeguimiento({ checked }) {
    const self = this;
    const inputParams = {
      empresa_rut: this.rut_empresa,
      codigo: this.productoOriginal.codigo,
    };

    if (checked === true) {
      //*Si se encuentra checkeado se debe verificar que no haya mas de 5
      this.productoService.ValidarProductoSeguimiento(inputParams, ({ respuesta, mensajes }) => {
        const ok = respuesta !== null;
        const alert = mensajes.length > 0;
        //*Si hay 5 o mas, arrojar mensaje de error
        if (alert) {
          self.modalVerErrores.loadAndShow(mensajes);
          this.formulario.get('seguimiento').setValue(false);
          return;
        }
      });
    }
  }

  ValidarSku(sku: string) {
    const inputParams = {
      empresa_rut: this.rut_empresa,
      sku,
      codigo_barras: '',
    };
    this.productoService.busquedaXSku(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) {
        this.toastService.error(`SKU ${sku} ya existe`);
        const invalidControl = this.element.nativeElement.querySelector('[formcontrolname="' + 'sku' + '"]');
        this.formulario.get('sku').setValue(null);
        invalidControl.focus();
        setTimeout(() => {
          this.limpiarLastSKU();
        }, 1100);
      }
    });
  }

  ValidarCodigoBarras(codigo_barras) {
    const inputParams = {
      empresa_rut: this.rut_empresa,
      sku: '',
      codigo_barras,
    };
    this.productoService.busquedaXCodigoDeBarra(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) {
        this.toastService.error(`Código de barras ${codigo_barras} ya existe`);
        const invalidControl = this.element.nativeElement.querySelector('[formcontrolname="' + 'codigo_barras' + '"]');
        this.formulario.get('codigo_barras').setValue(null);
        invalidControl.focus();
        setTimeout(() => {
          this.limpiarLastCodigoBarra();
        }, 1100);
      }
    });
  }

  obtenerFamiliasxRubros(rubro_codigo: number) {
    let self = this;
    this.client.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $rubro_codigo: Decimal) {
            familia {
              obtenerFamiliaxRubro(empresa_rut: $empresa_rut, rubro_codigo: $rubro_codigo) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    empresa_rut
                    rubro_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
          rubro_codigo: rubro_codigo,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const listaFamiliaRubro = respuesta.data.familia.obtenerFamiliaxRubro.respuesta.registros;
        self.optionsFamiliaRubros = [];
        var sel: any;
        listaFamiliaRubro.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsFamiliaRubros.push(sel);
        });
      }
    );
  }

  ValidarProductoSeguimiento() {
    this.parametroEmpresaService.permiteRealizarSeguimiento(this.rut_empresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.parametroSeguimiento = respuesta.valor_bool;
    });
  }

  showNew() {
    this.parametroUnidadNegocio();
    this.ValidarProductoSeguimiento();
    this.limpiarLastSKU();
    this.limpiarLastCodigoBarra();
    this.disabledContent = false;
    this.mode = 'ADD';
    this.formulario.reset();
    this.formulario.get('activo').disable();
    this.formulario.get('sku').enable();
    this.formulario.get('codigo_barras').enable();
    this.formulario.get('activo').setValue(false);
    this.formulario.get('es_exento').setValue(false);
    this.formulario.get('afecto_reglas_comerciales').setValue(false);
    this.formulario.get('no_aplica_descuento').setValue(false);
    this.formulario.get('favorito').setValue(false);
    this.formulario.get('tipo_producto_codigo').setValue(1);
    this.formulario.get('seguimiento').setValue(false);
    this.ObtenerFormatoCombinacion1(0);
    this.ObtenerFormatoCombinacion2(0);
    this.optionsFamiliaRubros = [];
    this.listaProductoFormato = [];
    this.codigo_impuesto = 0;

    const self = this;
    let codigo_operacion = 12;
    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rut_usuario,
          codgo_modulo: self.codgo_modulo,
          cod_operacion: codigo_operacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
          // self.addEditProductoModal.show()
        } else {
          self.messageRendererService.showErrors(notificacion.mensajes);
          // alert(notificacion.mensajes[0].texto);
        }
      }
    );
  }

  limpiarLastSKU() {
    this.lastSku = '';
  }

  limpiarLastCodigoBarra() {
    this.lastCodigoBarra = '';
  }

  showEdit(pro: producto) {
    this.ValidarProductoSeguimiento();
    this.isEditingStarted = false;
    this.disabledContent = false;
    this.mode = 'EDIT';
    this.formulario.get('formato').setValue('');
    this.formulario.get('volumen').setValue('');
    this.formulario.get('peso').setValue('');
    this.codigo_impuesto = 0;
    this.formulario.get('seguimiento').setValue(pro.seguimiento);
    this.formulario.get('activo').enable();
    this.formulario.get('sku').disable();
    // this.formulario.get('codigo_barras').disable();
    this.formulario.get('codigo').setValue(pro.codigo);
    this.productoOriginal = pro;
    this.formulario.get('empresa_rut').setValue(pro.empresa_rut);
    this.formulario.get('sku').setValue(pro.sku);
    this.formulario.get('descripcion').setValue(pro.descripcion.trim());
    this.formulario.get('descripcion_ext').setValue(pro.descripcion_ext);
    this.formulario.get('es_exento').setValue(pro.es_exento);
    this.formulario.get('codigo_barras').setValue(pro.codigo_barras);
    this.currentCodigoBarra = pro.codigo_barras;
    this.formulario.get('fecha_registro').setValue(pro.fecha_registro);
    this.formulario.get('activo').setValue(pro.activo);
    this.formulario.get('favorito').setValue(pro.favorito);
    this.formulario.get('tipo_producto_codigo').setValue(pro.tipo_producto_codigo);
    this.formulario.get('unidad_medida_codigo').setValue(pro.unidad_medida_codigo);
    this.formulario.get('afecto_reglas_comerciales').setValue(pro.afecto_reglas_comerciales);
    this.formulario.get('no_aplica_descuento').setValue(pro.no_aplica_descuento);
    this.formulario.get('fecha_caducidad_combo').setValue(pro.fecha_caducidad_combo);
    this.formulario.get('fecha_inicio_combo').setValue(pro.fecha_inicio_combo);
    this.formulario.get('rubro_codigo').setValue(pro.rubro_codigo);
    if (pro.unidad_negocio_codigo === null) {
      this.formulario.get('unidad_negocio_codigo').setValue('');
    } else {
      this.formulario.get('unidad_negocio_codigo').setValue(pro.unidad_negocio_codigo);
    }
    this.fecha_registro = pro.fecha_registro;
    this.obtenerElementosProducto(pro.codigo, 'showForEditDatosProductos');
    this.parametroUnidadNegocio();
    this.setDataModificarDtoProducto();
    this.ObtenerFormatoCombinacion1(pro.codigo);
    this.ObtenerFormatoCombinacion2(pro.codigo);
    this.isEditingStarted = true;
  }

  ObtenerFormatoCombinacion1(producto_codigo: number) {
    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        producto_codigo: producto_codigo,
      },
    };
    this.formatoProductosService.GetFormatosCombinacion1(inputParams, ({ respuesta }) => {
      const registro = respuesta;
      this.formatoNombreComb1 = registro.formato_nombre;
      this.formulario.get('formato_combinacion1').setValue(registro.cantidad);
    });
  }

  ObtenerFormatoCombinacion2(producto_codigo: number) {
    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        producto_codigo: producto_codigo,
      },
    };
    this.formatoProductosService.GetFormatosCombinacion2(inputParams, ({ respuesta }) => {
      const registro = respuesta;
      this.formatoNombreComb2 = registro.formato_nombre;
      this.formulario.get('formato_combinacion2').setValue(registro.cantidad);
    });
  }

  setDataModificarDtoProducto() {
    const self = this;
    let codigo_operacion = 13;
    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rut_usuario,
          codgo_modulo: self.codgo_modulo,
          cod_operacion: codigo_operacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
          // self.addEditProductoModal.show()
        } else {
          self.messageRendererService.showErrors(notificacion.mensajes);
          // alert(notificacion.mensajes[0].texto);
        }
      }
    );
  }

  showModalImpuestos() {
    this.modalSeleccionarImpuestos.loadAndShow(this.codigo_impuesto);
  }

  capturaImpuesto(impuesto: number) {
    this.codigo_impuesto = impuesto;
  }

  setDefaultValueWhenNullOrEmpty(field: string, value: number = 0) {
    this.log(field, this.formulario.controls[field].value);
    if (!this.formulario.controls[field].value) this.formulario.controls[field].setValue(value);
  }

  agregarFormatos() {
    this.setDefaultValueWhenNullOrEmpty('peso');
    this.setDefaultValueWhenNullOrEmpty('volumen');

    let empresa_rut = this.rut_empresa;
    let producto_codigo = 0;
    let formato_codigo = this.formulario.controls['formato'].value;
    let formato_nombre = '';
    let peso_neto = this.formulario.controls['peso'].value;
    let fecha_registro = new Date();
    let cantidad = 0;
    let activo = true;
    let formato_codigo_top = '';
    let formato_secundario = '';
    let volumen = this.formulario.controls['volumen'].value;
    var sel: any;
    var arr = [];

    if (formato_codigo == null) {
      this.toastService.error('Seleccione formato');
      return;
    }

    if (formato_codigo.toString() == '' || peso_neto.toString() == '' || volumen.toString() == '') {
      return;
    }
    this.listaFormato.forEach((element) => {
      if (element.codigo == this.formulario.controls['formato'].value) {
        formato_nombre = element.nombre;
        cantidad = element.cantidad;
      }
    });

    for (let item of this.listaProductoFormato) {
      arr = [item['formato_codigo'], item['formato_nombre']];
      formato_codigo_top = item.formato_codigo_top;
      formato_secundario = item.formato_secundario;
      var idx = arr.indexOf(formato_codigo);
      if (idx != -1) {
        this.toastService.error('El formato ya se encuentra agregado');
        // alert('El formato ya se encuentra agregada');
        return;
      }
    }

    sel = {
      empresa_rut,
      producto_codigo,
      formato_codigo,
      formato_nombre,
      peso_neto,
      fecha_registro,
      cantidad,
      activo,
      formato_codigo_top,
      formato_codigo2: formato_codigo,
      formato_secundario,
      volumen,
    };
    this.listaProductoFormato.push(sel);
    this.formulario.get('formato').setValue('');
    this.formulario.get('volumen').setValue('');
    this.formulario.get('peso').setValue('');

    this.setearFormatoPorDefecto();
  }

  setearFormatoPorDefecto() {
    this.log('listaProductoFormato', JSON.stringify(this.listaProductoFormato));
    if (this.listaProductoFormato && this.listaProductoFormato.length > 0) {
      // TODO: Setear solo el que esté activa
      const _listaDefecto = this.listaProductoFormato.filter((p) => p.activo && p.formato_codigo_top === p.formato_codigo);
      if (_listaDefecto && _listaDefecto.length > 0) return;
      const listaActivos = this.listaProductoFormato.filter((p) => p.activo);
      if (listaActivos.length > 0) listaActivos[0].formato_codigo_top = listaActivos[0].formato_codigo;
      else this.listaProductoFormato[0].formato_codigo_top = this.listaProductoFormato[0].formato_codigo;
    }
  }

  cambiarEstado(formatoProducto: producto_formatoJoin) {
    const listaActivos = this.listaProductoFormato.filter((p) => p.activo);
    if (listaActivos.length === 1 && listaActivos[0].formato_codigo === formatoProducto.formato_codigo) {
      this.toastService.error('Debe dejar un formato activo');
      return;
    }

    formatoProducto.activo = !formatoProducto.activo;
    this.setearFormatoPorDefecto();
  }

  handleChangeAgregar({ formato_codigo, activo }) {
    this.log('formatoProducto', formato_codigo, activo);
    if (!activo) {
      this.toastService.error('Formato principal debe estar activo');
      return;
    }
    this.listaProductoFormato.forEach((element) => {
      element.formato_codigo_top = formato_codigo;
    });
    // if (!activo) {
    //   this.setearFormatoPorDefecto()
    // }
  }

  handleChangeAgregarSecundario({ formato_codigo, activo }) {
    //handleChange
    this.log('formatoProductoSecundario', formato_codigo, activo);
    if (!activo) {
      this.toastService.error('Formato Secundario debe estar activo');
      return;
    }
    this.listaProductoFormato.forEach((element) => {
      element.formato_secundario = formato_codigo;
    });
  }

  // handleChangeEditar(evt) {
  //   this.listaProductoFormato.forEach(element => {
  //     element.formato_codigo_top = evt
  //   })
  // }

  eliminarFormatoAgregados(index) {
    this.modalConfirm.showWithInlineConfig('Eliminar formato', '¿Desea eliminar el formato?', () => {
      this.listaProductoFormato.splice(index, 1);
      this.setearFormatoPorDefecto();
    });
  }

  showEditarPesoVolumen(productoFormato: producto_formatoJoin) {
    this.formulario.get('formato').setValue(productoFormato.formato_codigo);
    this.modalSeleccionarPesoVolumen.loadAndShow(productoFormato);
  }

  onVolumenPesoSeleccionado(newValues: any) {
    const _lista = this.listaProductoFormato.filter((f) => f.formato_codigo === newValues.formato_codigo);
    if (_lista.length > 0) {
      _lista[0].peso_neto = newValues.peso;
      _lista[0].volumen = newValues.volumen;
    }
  }

  postProductoImpuesto(codigo_producto: number) {
    const self = this;
    const bodyx: producto_impuesto = new producto_impuesto();
    bodyx.empresa_rut = this.rut_empresa;
    bodyx.producto_codigo = codigo_producto;
    bodyx.impuesto_codigo = this.codigo_impuesto;
    bodyx.fecha_registro = new Date();
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: producto_impuestoInputType) {
            producto_impuesto {
              guardar(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  impuesto_codigo
                  fecha_registro
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.producto_impuesto.guardar.respuesta != undefined) {
          setTimeout(() => self.obtenerElementosProducto(codigo_producto, 'postProductoImpuesto'), 1000);
        }
      }
    );
  }

  guardarProductoFormato(lista_: producto_formatoJoin[], producto_codigo: number) {
    const lista = _.cloneDeep(lista_);
    for (var i = 0; i < lista.length; i++) {
      lista[i].producto_codigo = producto_codigo;
      delete lista[i]['__typename'];
      delete lista[i].formato_nombre;
    }
    let self = this;
    var bodyx = lista;
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: producto_formatoListaInputType, $empresa_rut: Decimal, $producto_codigo: Decimal) {
            producto_formato {
              guardarProductoFormatos(entidad: $entidad, empresa_rut: $empresa_rut, producto_codigo: $producto_codigo) {
                mensajes {
                  codigo
                  tipo
                  contexto
                  texto
                }
              }
            }
          }
        `,
        variables: {
          entidad: {
            objet: bodyx,
          },
          empresa_rut: this.rut_empresa,
          producto_codigo: producto_codigo,
        },
      },
      function (mensajes) {
        if (mensajes.data.producto_formato.guardarProductoFormatos.mensajes != undefined) {
          setTimeout(() => self.obtenerElementosProducto(producto_codigo, 'guardarProductoFormato'), 1000);
        }
      }
    );
  }

  obtenerElementosProducto(producto_codigo: number, origen: string) {
    let self = this;
    this.client.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $producto_codigo: Decimal) {
            familia {
              obtenerFamiliaProducto(entidad: { empresa_rut: $empresa_rut }, producto_codigo: $producto_codigo) {
                respuesta {
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                }
              }
            }

            unidad_medida {
              obtenerUnidad_MedidaProducto(producto_codigo: $producto_codigo) {
                respuesta {
                  codigo
                  nombre
                }
              }
            }

            producto_impuesto {
              obtenerSegunIdProducto(entidad: { empresa_rut: $empresa_rut, producto_codigo: $producto_codigo }) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  impuesto_codigo
                  fecha_registro
                  factor
                  valor
                }
              }
            }

            producto_formato {
              obtenerProductosFormatos(filtro: { exacto: { empresa_rut: $empresa_rut, producto_codigo: $producto_codigo } }) {
                respuesta {
                  registros {
                    empresa_rut
                    producto_codigo
                    formato_codigo
                    formato_nombre
                    peso_neto
                    volumen
                    fecha_registro
                    cantidad
                    activo
                    formato_codigo_top
                    formato_secundario
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
          producto_codigo: producto_codigo,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        let codigo_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.codigo;
        let nombre_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.nombre;
        setTimeout(() => self.formulario.controls['familia_codigo'].setValue(codigo_familia), 300);
        // setTimeout(() => self.formResumen.controls["familia"].setValue(nombre_familia), 300);

        let codigo_unidad_medida = respuesta.data.unidad_medida.obtenerUnidad_MedidaProducto.respuesta.codigo;
        if (codigo_unidad_medida != 0) {
          self.formulario.controls['unidad_medida_codigo'].setValue(codigo_unidad_medida);
        } else {
          self.formulario.controls['unidad_medida_codigo'].setValue('');
        }

        const seleccionProductoImpuestoJoin = respuesta.data.producto_impuesto.obtenerSegunIdProducto.respuesta;
        if (seleccionProductoImpuestoJoin != null) {
          self.codigo_impuesto = seleccionProductoImpuestoJoin.impuesto_codigo;
          self.impuestoAdicPro = seleccionProductoImpuestoJoin.valor;
        } else {
          self.codigo_impuesto = 0;
        }

        self.listaProductoFormato = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
        self.listaProductoFormato.map((produc: any) => {
          (produc.formato_codigo2 = produc.formato_codigo), (produc.formato_secundario = produc.formato_secundario == null ? '' : produc.formato_secundario);
        });

        // self.listaProductoFormatoResumen = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
        // self.optionsFormatoProducto = [];
        // var sel: any;
        self.listaProductoFormato.forEach(element => {
          element.volumen = Number(element.volumen.toFixed(2))
        });
      }
    );
  }

  showSuccess() {
    const options = { opacity: 1 };
    this.toastService.success('Registro grabado!', 'Información!', options);
  }

  actualizarDatosProductos(listaFormato: producto_formatoJoin[]) {
    const seleccionProducto: producto = {
      codigo: 0,
      empresa_rut: 0,
      sku: '',
      descripcion: '',
      descripcion_ext: '',
      es_exento: false,
      codigo_barras: '',
      fecha_registro: new Date(),
      activo: false,
      favorito: false,
      familia_codigo: 0,
      tipo_producto_codigo: 0,
      unidad_medida_codigo: 0,
      afecto_reglas_comerciales: false,
      no_aplica_descuento: false,
      fecha_caducidad_combo: null,
      fecha_inicio_combo: null,
      rubro_codigo: 0,
      unidad_negocio_codigo: null,
      seguimiento: false,
    };
    seleccionProducto.empresa_rut = this.rut_empresa;
    seleccionProducto.codigo = this.formulario.controls['codigo'].value;
    seleccionProducto.sku = this.formulario.controls['sku'].value;
    seleccionProducto.descripcion = this.formulario.controls['descripcion'].value;
    seleccionProducto.descripcion_ext = this.formulario.controls['descripcion_ext'].value;
    seleccionProducto.es_exento = this.formulario.controls['es_exento'].value;
    seleccionProducto.codigo_barras =
      this.formulario.controls['codigo_barras'].value && this.formulario.controls['codigo_barras'].value.trim() ? this.formulario.controls['codigo_barras'].value.trim() : null;
    seleccionProducto.fecha_registro = this.formulario.controls['fecha_registro'].value;
    seleccionProducto.activo = this.formulario.controls['activo'].value;
    seleccionProducto.favorito = this.formulario.controls['favorito'].value;
    seleccionProducto.familia_codigo = this.formulario.controls['familia_codigo'].value;
    seleccionProducto.tipo_producto_codigo = this.formulario.controls['tipo_producto_codigo'].value;
    seleccionProducto.afecto_reglas_comerciales = this.formulario.controls['afecto_reglas_comerciales'].value;
    seleccionProducto.no_aplica_descuento = this.formulario.controls['no_aplica_descuento'].value;
    seleccionProducto.rubro_codigo = this.formulario.controls['rubro_codigo'].value;
    if (this.formulario.controls['unidad_medida_codigo'].value == '') {
      seleccionProducto.unidad_medida_codigo = 0;
    } else {
      seleccionProducto.unidad_medida_codigo = this.formulario.controls['unidad_medida_codigo'].value;
    }
    if (this.formulario.controls['unidad_negocio_codigo'].value == '') {
      seleccionProducto.unidad_negocio_codigo = null;
    } else {
      seleccionProducto.unidad_negocio_codigo = this.formulario.controls['unidad_negocio_codigo'].value;
    }
    delete seleccionProducto['__typename'];
    this.postProductoEditar(listaFormato, seleccionProducto);
  }

  postProductoEditar(listaFormato: producto_formatoJoin[], pro: producto) {
    const self = this;
    const bodyx = pro;
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: productoInputType, $sucursal_codigo: Decimal) {
            producto {
              guardar(entidad: $entidad, sucursal_codigo: $sucursal_codigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sku
                  codigo_barras
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
          sucursal_codigo: this.sucursal_codigo,
        },
      },
      function (respuesta) {
        if (respuesta.data.producto.guardar.respuesta != null) {
          let pro = respuesta.data.producto.guardar.respuesta.codigo;
          self.postProductoImpuesto(pro);
          self.guardarProductoFormato(listaFormato, pro);
          self.showSuccess();
          // self.addEditProductoModal.hide();
        } else {
          self.toastService.error(respuesta.data.producto.guardar.mensajes[0].texto);
          // alert(respuesta.data.producto.guardar.mensajes[0].texto);
        }
        // setTimeout(() => self.obtenerDatosProducto(), 1000);
        self.onSuccess.emit(pro.codigo);
      }
    );
  }

  editarFormatos() {
    this.setDefaultValueWhenNullOrEmpty('peso');
    this.setDefaultValueWhenNullOrEmpty('volumen');
    let empresa_rut = this.rut_empresa;
    let producto_codigo = this.productoOriginal.codigo;
    let formato_codigo = this.formulario.controls['formato'].value;
    let formato_nombre = '';
    let peso_neto = this.formulario.controls['peso'].value;
    let fecha_registro = new Date();
    let cantidad = 0;
    let activo = true;
    let formato_codigo_top = '';
    let formato_secundario = '';
    let volumen = this.formulario.controls['volumen'].value;
    var sel: any;
    var arr = [];

    if (formato_codigo == null || peso_neto == null || volumen == null) {
      return;
    }

    if (formato_codigo.toString() == '' || peso_neto.toString() == '' || volumen.toString() == '') {
      return;
    }
    this.listaFormato.forEach((element) => {
      if (element.codigo == this.formulario.controls['formato'].value) {
        formato_nombre = element.nombre;
        cantidad = element.cantidad;
      }
    });

    for (let item of this.listaProductoFormato) {
      arr = [item['formato_codigo'], item['formato_nombre']];
      formato_codigo_top = item.formato_codigo_top;
      var idx = arr.indexOf(formato_codigo);
      if (idx != -1) {
        this.toastService.error('El formato ya se encuentra agregado');
        // alert('El formato ya se encuentra agregada');
        return;
      }
    }
    sel = {
      empresa_rut,
      producto_codigo,
      formato_codigo,
      formato_nombre,
      peso_neto,
      fecha_registro,
      cantidad,
      activo,
      formato_codigo_top,
      formato_secundario,
      volumen,
    };
    this.listaProductoFormato.push(sel);
    this.formulario.get('formato').setValue('');
    this.formulario.get('volumen').setValue('');
    this.formulario.get('peso').setValue('');
  }

  guardar() {
    switch (this.mode) {
      case 'ADD':
        {
          this.VerificarAndAgregar();
        }
        break;
      case 'EDIT':
        {
          // this.actualizarDatosProductos(this.listaProductoFormato)
          this.VerificarAndEditar();
        }
        break;
    }
  }

  VerificarAndAgregar() {
    const inputParams = {
      empresa_rut: this.rut_empresa,
      sku: this.formulario.get('sku').value,
      codigo_barras: this.formulario.get('codigo_barras').value,
    };
    this.productoService.busquedaXSkuAndCodigoBarra(inputParams, ({ respuesta, mensajes }) => {
      this.log('Verificar y agregar', respuesta, mensajes);
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) {
        this.toastService.error(`Producto ya existe`);
        // const invalidControl = this.element.nativeElement.querySelector('[formcontrolname="' + 'sku' + '"]');
        // invalidControl.focus();
        return;
      }
      this.AgregarProducto();
    });
  }

  AgregarProducto() {
    const listaProductoFormato = _.cloneDeep(this.listaProductoFormato).map((productoFormato) => ({
      formato_codigo: productoFormato.formato_codigo,
      peso_neto: productoFormato.peso_neto,
      volumen: productoFormato.volumen,
      cantidad: productoFormato.cantidad,
      activo: productoFormato.activo,
      formato_codigo_top: productoFormato.formato_codigo_top,
      formato_secundario: productoFormato.formato_secundario,
    }));

    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        sku: this.formulario.get('sku').value,
        codigo_barras:
          this.formulario.controls['codigo_barras'].value && this.formulario.controls['codigo_barras'].value.trim().length > 0 ? this.formulario.controls['codigo_barras'].value.trim() : null,
        // codigo_barras: null,
        descripcion: this.formulario.controls['descripcion'].value,
        descripcion_ext: this.formulario.controls['descripcion_ext'].value,
        es_exento: this.formulario.controls['es_exento'].value,
        afecto_reglas_comerciales: this.formulario.controls['afecto_reglas_comerciales'].value,
        no_aplica_descuento: this.formulario.controls['no_aplica_descuento'].value,
        favorito: this.formulario.controls['favorito'].value,
        activo: this.formulario.controls['activo'].value,
        unidad_medida_codigo: this.formulario.controls['unidad_medida_codigo'].value ? this.formulario.controls['unidad_medida_codigo'].value : 0,
        rubro_codigo: this.formulario.controls['rubro_codigo'].value,
        familia_codigo: this.formulario.controls['familia_codigo'].value,
        unidad_negocio_codigo: this.formulario.controls['unidad_negocio_codigo'].value,
        cant_formato_combinacion1: this.formulario.controls['formato_combinacion1'].value,
        cant_formato_combinacion2: this.formulario.controls['formato_combinacion2'].value,
        productoFormato: listaProductoFormato,
        seguimiento: this.formulario.get('seguimiento').value,
        productoImpuesto: {
          impuesto_codigo: this.codigo_impuesto,
        },
        rut_usuario_modificacion: this.rut_usuario,
      },
    };

    //validar que si selecciona dos formatos, uno debe ser principal y otro secundario
    const filtroFormatoPrincipal = listaProductoFormato.filter((x) => x.formato_codigo_top == x.formato_codigo && x.activo == true); // trae formato Principal
    const filtroFormatoSecundario = listaProductoFormato.filter((x) => x.formato_secundario == x.formato_codigo); // trae formato Secundario
    const filtroFormatosNoPrincipal = listaProductoFormato.filter((x) => x.formato_codigo_top != x.formato_codigo && x.activo == true);

    // if (filtroFormatoSecundario.length > 0) {
    //   listaProductoFormato.map((x) => {
    //     x.formato_secundario = '';
    //   });
    // }

    if (listaProductoFormato.length == 1) {
      if (filtroFormatoPrincipal[0].formato_secundario == filtroFormatoPrincipal[0].formato_codigo) {
        this.toastService.warning('No se puede tener el mismo formato como principal y secundario.');
        return;
      }

      if (filtroFormatoPrincipal.length == 0) {
        this.toastService.warning('Seleccione un producto Formato Principal.');
        return;
      }
    } else {
      if (filtroFormatoPrincipal[0].formato_secundario == filtroFormatoPrincipal[0].formato_codigo) {
        this.toastService.warning('No se puede tener el mismo formato como principal y secundario.');
        return;
      }

      if (filtroFormatoPrincipal.length == 0) {
        this.toastService.warning('Seleccione un producto Formato Principal.');
        return;
      }

      if (filtroFormatoPrincipal[0].formato_secundario == '' && filtroFormatosNoPrincipal.length > 0) {
        this.toastService.warning('Seleccione un producto Formato Secundario.');
        return;
      }
    }

    this.log('inputParams', JSON.stringify(inputParams));
    this.productoService.agregarProducto(inputParams, ({ respuesta, mensajes }) => {
      this.log('{ respuesta, mensajes }', respuesta, mensajes);
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.showSuccess();
      this.log('saved', respuesta.codigo, respuesta);
      this.onSuccess.emit(respuesta.codigo);
    });
  }

  VerificarAndEditar() {
    if (!this.formulario.get('codigo_barras').value || this.formulario.get('codigo_barras').value.length === 0 || this.currentCodigoBarra === this.formulario.get('codigo_barras').value) {
      this.EditarProducto();
      return;
    }

    // Validar codigo de barras
    const inputParams = {
      empresa_rut: this.rut_empresa,
      sku: '',
      codigo_barras: this.formulario.get('codigo_barras').value,
    };
    this.productoService.busquedaXCodigoDeBarra(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta && respuesta.sku !== this.formulario.get('sku').value) {
        this.toastService.error(`Código de barras ${this.formulario.get('codigo_barras').value} ya existe`);
        return;
      }
      this.EditarProducto();
    });
  }

  EditarProducto() {
    this.log('Editar');
    const listaProductoFormato = _.cloneDeep(this.listaProductoFormato).map((productoFormato) => ({
      formato_codigo: productoFormato.formato_codigo,
      peso_neto: productoFormato.peso_neto,
      volumen: productoFormato.volumen,
      cantidad: productoFormato.cantidad,
      activo: productoFormato.activo,
      formato_codigo_top: productoFormato.formato_codigo_top,
      formato_secundario: productoFormato.formato_secundario,
      empresa_rut: productoFormato.empresa_rut,
      producto_codigo: productoFormato.producto_codigo,
      fecha_registro: productoFormato.fecha_registro,
    })).sort((a, b) => new Date(a.fecha_registro).getTime() - new Date(b.fecha_registro).getTime());

    const inputParams = {
      entidad: {
        codigo: this.productoOriginal.codigo,
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        sku: this.formulario.get('sku').value,
        codigo_barras:
          this.formulario.controls['codigo_barras'].value && this.formulario.controls['codigo_barras'].value.trim().length > 0 ? this.formulario.controls['codigo_barras'].value.trim() : null,
        // codigo_barras: null,
        descripcion: this.formulario.controls['descripcion'].value,
        descripcion_ext: this.formulario.controls['descripcion_ext'].value,
        es_exento: this.formulario.controls['es_exento'].value,
        afecto_reglas_comerciales: this.formulario.controls['afecto_reglas_comerciales'].value,
        no_aplica_descuento: this.formulario.controls['no_aplica_descuento'].value,
        favorito: this.formulario.controls['favorito'].value,
        activo: this.formulario.controls['activo'].value,
        unidad_medida_codigo: this.formulario.controls['unidad_medida_codigo'].value ? this.formulario.controls['unidad_medida_codigo'].value : 0,
        rubro_codigo: this.formulario.controls['rubro_codigo'].value,
        familia_codigo: this.formulario.controls['familia_codigo'].value,
        productoFormato: listaProductoFormato,
        tipo_producto_codigo: this.productoOriginal.tipo_producto_codigo,
        unidad_negocio_codigo: this.formulario.controls['unidad_negocio_codigo'].value,
        cant_formato_combinacion1: this.formulario.controls['formato_combinacion1'].value, // CAMA
        cant_formato_combinacion2: this.formulario.controls['formato_combinacion2'].value, // PALET
        seguimiento: this.formulario.get('seguimiento').value,
        productoImpuesto: {
          empresa_rut: this.rut_empresa,
          producto_codigo: this.productoOriginal.codigo,
          impuesto_codigo: this.codigo_impuesto,
        },
        rut_usuario_modificacion: this.rut_usuario,
      },
    };

    //validar que si selecciona dos formatos, uno debe ser principal y otro secundario
    const filtroFormatoPrincipal = listaProductoFormato.filter((x) => x.formato_codigo_top == x.formato_codigo && x.activo == true); // trae formato Principal
    const filtroFormatoSecundario = listaProductoFormato.filter((x) => x.formato_secundario == x.formato_codigo); // trae formato Secundario
    const filtroFormatosNoPrincipal = listaProductoFormato.filter((x) => x.formato_codigo_top != x.formato_codigo && x.activo == true);

    // if (filtroFormatoSecundario.length > 0) {
    //   listaProductoFormato.map((x) => {
    //     x.formato_secundario = '';
    //   });
    // }

    if (listaProductoFormato.length == 1) {
      if (filtroFormatoPrincipal[0].formato_secundario == filtroFormatoPrincipal[0].formato_codigo) {
        this.toastService.warning('No se puede tener el mismo formato como principal y secundario.');
        return;
      }

      if (filtroFormatoPrincipal.length == 0) {
        this.toastService.warning('Seleccione un producto Formato Principal.');
        return;
      }
    } else {
      if (filtroFormatoPrincipal[0].formato_secundario == filtroFormatoPrincipal[0].formato_codigo) {
        this.toastService.warning('No se puede tener el mismo formato como principal y secundario.');
        return;
      }

      if (filtroFormatoPrincipal.length == 0) {
        this.toastService.warning('Seleccione un producto Formato Principal.');
        return;
      }

      if (filtroFormatoPrincipal[0].formato_secundario == '' && filtroFormatosNoPrincipal.length > 0) {
        this.toastService.warning('Seleccione un producto Formato Secundario.');
        return;
      }
    }

    this.log('inputParams', inputParams);
    this.log('listaProductoFormato', listaProductoFormato);
    this.log('listaProductoFormato', this.listaProductoFormato);
    this.productoService.editarProducto(inputParams, ({ respuesta, mensajes }) => {
      this.log('{ respuesta, mensajes }', respuesta, mensajes);
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.showSuccess();
      this.onSuccess.emit(this.productoOriginal.codigo);
    });
  }

  public validate() {
    return this.formValidatorsService.validate(this.formulario) && this.listaProductoFormato && this.listaProductoFormato.length > 0;
  }

  public disable() {
    this.disabledContent = true;
  }
}
